/**
 * phase1TaskColumns.ts
 * FEAT-2026-0007 Phase 6B.4 — Column configuration for the Phase-1 scenario task table.
 * Phase 6.5 — Added Machine Time column (MachineMinutes from MachineTaskCapability).
 *
 * Per CODING-STANDARDS.md: column configs are data objects, not inline JSX.
 *
 * Columns shown in Phase 1 (Machine planning):
 *   # · Task Name · Test Qty · Machine Qty (edit) · Assigned Machine(s) · Start Date · End Date · Duration (Days) · Machine Time
 *
 * Intentionally omits the "Assignees" column — that belongs to Phase 2 (6C.1).
 */

export interface Phase1TaskColumn {
  id: string;
  label: string;
  width: string | number;
  align?: 'left' | 'center' | 'right';
  tooltip?: string;
}

export const PHASE1_TASK_COLUMNS: Phase1TaskColumn[] = [
  {
    id: 'rowNumber',
    label: '#',
    width: '3%',
    align: 'center',
  },
  {
    id: 'Name',
    label: 'Task Name',
    width: '20%',
    align: 'left',
  },
  {
    id: 'TestQty',
    label: 'Test Qty',
    width: '7%',
    align: 'center',
    tooltip: 'Number of tests requested in the source quote or work order line item.',
  },
  {
    id: 'MachineCount',
    label: 'Machine Qty',
    width: '8%',
    align: 'center',
    tooltip: 'Number of machines running in parallel — increasing reduces span proportionally.',
  },
  {
    id: 'Machines',
    label: 'Assigned Machine(s)',
    width: '20%',
    align: 'left',
    tooltip: 'Dropdown filtered to machines capable of this task type.',
  },
  {
    id: 'StartDate',
    label: 'Start Date',
    width: '10%',
    align: 'center',
    tooltip: 'Edit to push this task to a later date. End auto-recomputes.',
  },
  {
    id: 'EndDate',
    label: 'End Date',
    width: '10%',
    align: 'center',
    tooltip: 'Auto-derived from Start + per-machine span.',
  },
  {
    id: 'Duration',
    label: 'Duration (Days)',
    width: '9%',
    align: 'center',
    // Run Mode Phase C: per-mode unit (working days vs calendar days 24/7).
    tooltip: 'Computed from Start and End dates — inclusive WORKING days for attended tasks, CALENDAR days for Continuous (24/7) tasks. Edit by changing Start or Machine Qty.',
  },
  {
    id: 'MachineTime',
    label: 'Machine Time',
    width: '9%',
    align: 'center',
    tooltip: 'Machine time as rate × quantity = total minutes (e.g. 45 × 25 = 1,125 min). The per-test rate comes from the MachineTaskCapability mapping, set by an admin in the Machine Catalog.',
  },
  {
    id: 'actions',
    label: '',
    width: '5%',
    align: 'center',
  },
];
